import { Box, Typography } from '@mui/material'
import { Person, PersonOff, PersonAdd } from '@mui/icons-material'
import React from 'react'
import PropTypes from 'prop-types'

const statusValues = PropTypes.oneOf(['occupied', 'available', 'selected'])

const statusConfig = {
  occupied: { icon: Person, color: 'warning', label: 'Siège occupé' },
  available: { icon: PersonOff, color: 'success', label: 'Siège disponible' },
  selected: { icon: PersonAdd, color: 'info', label: 'Siège sélectionné' }
}

export default function SeatStatusBanner({ status }) {
  const config = statusConfig[status] || statusConfig.selected

  return (
    <Box
      sx={{
        bgcolor: `${config.color}.light`,
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        borderRadius: 2,
        mb: 2
      }}
    >
      {config.icon && <config.icon sx={{ color: `${config.color}.dark`, fontSize: 28 }} />}
      <Typography variant='h6' sx={{ fontWeight: 600 }}>
        {config.label}
      </Typography>
    </Box>
  )
}

SeatStatusBanner.propTypes = {
  status: statusValues.isRequired
}
